var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlobOutline = function SvgBlobOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.213.306A12.013 12.013 0 0 1 24 11.246V19a5.006 5.006 0 0 1-5 5h-6.983A12.012 12.012 0 0 1 9.213.306M12.02 2q-.651 0-1.3.082a10.044 10.044 0 0 0-8.656 8.76 9.92 9.92 0 0 0 2.476 7.815A10.04 10.04 0 0 0 12.017 22H19a3 3 0 0 0 3-3v-7.658A10.04 10.04 0 0 0 18.4 4.3 9.92 9.92 0 0 0 12.021 2",
    clipRule: "evenodd"
  })));
};
export default SvgBlobOutline;